// extracted by mini-css-extract-plugin
export var phone = "_26-0";